module.exports = __webpack_public_path__ + "img/ohniste_1.e2568d3a.jpg";